export default function isReactElement(
  child: React.ReactChild | React.ReactNode,
): child is React.ReactElement<any> {
  return typeof child === 'object'
}
